
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { LOCALIZED_HOUSE_RESULTS } from '@constants/routes';
import { userHasAccess } from '@utils/profile';
import { useUserContext } from '@contexts/user-context';
import ProfilePromo from '../ProfilePromo';
import s from './ContentPanel.module.scss';
import localizedHousePromoBG from './img/localized_promo_bg.png';
const propTypes = {
    profileData: PropTypes.shape({
        sections: PropTypes.array
    }).isRequired,
    activeModal: PropTypes.bool
};
const ContentPanel = ({ profileData, activeModal = false }) => {
    const { sections } = profileData;
    const { t, lang } = useTranslation('house-results');
    const userContext = useUserContext();
    const house = userContext?.profile?.hogwartsHouse?.toLowerCase();
    const hardcodedLocalizedSection = {
        layout: 'list',
        externalId: 'hardcoded-localized-promo-section',
        sectionTitle: '',
        promos: [
            {
                contentfulId: 'hardcoded-localized-promo',
                externalId: 'hardcoded-localized-promo',
                displayTitle: t('see-your-sorting-results'),
                entryTitle: t('see-your-sorting-results'),
                contentTypeId: 'promo',
                url: `${LOCALIZED_HOUSE_RESULTS}/${house}`,
                mainImage: {
                    image: {
                        file: {
                            url: localizedHousePromoBG
                        }
                    }
                }
            },
        ]
    };
    const getValidPromos = (promos) => {
        return promos.filter((promo) => {
            return userHasAccess(promo, userContext) || promo.fallbackContent;
        });
    };
    const generatePromoMarkup = (promo, section) => {
        const { contentfulId } = promo;
        return (<ProfilePromo key={`promo-${contentfulId}`} className={s.promo} promo={promo} section={section}/>);
    };
    const generateSectionMarkup = (section) => {
        const { promos, layout, externalId, sectionTitle } = section;
        const validPromos = getValidPromos(promos || []);
        if (validPromos.length) {
            return (<div key={`section-${externalId}`} className={cx(s.section, s[`${layout || 'list'}`])}>
          <h2 className={s.sectionHeader}>{sectionTitle}</h2>
          <div className={s.promoContainer}>
            {validPromos.map((promo) => generatePromoMarkup(promo, section))}
          </div>
        </div>);
        }
        return false;
    };
    if (!sections || !sections.length) {
        return null;
    }
    // Add hardcoded localized promo section to the beginning of the sections array
    // for non-english users
    if (!sections.find((section) => section.externalId === 'hardcoded-localized-promo-section') &&
        house &&
        lang !== 'en') {
        sections.unshift(hardcodedLocalizedSection);
    }
    return (<div className={[s.contentPanel, activeModal ? s.activeModal : ''].join(' ')}>
      {sections.map((section) => generateSectionMarkup(section))}
    </div>);
};
ContentPanel.propTypes = propTypes;
export default ContentPanel;

    async function __Next_Translate__getStaticProps__195ca0e9f98__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//Profile/components/ContentPanel/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0e9f98__ as getStaticProps }
  